<script setup lang="ts">
import IconTabBarTopProfile from '@/shared/assets/icons/IconTabBarTopProfile.svg'

import CabHeaderNavWrap from './CabHeaderNavWrap.vue'

defineProps({
  to: {
    type: String,
    required: true,
  },
  inCall: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <CabHeaderNavWrap :to="to" :in-call="inCall" data-test="widget_header__button_top-profiles">
    <IconTabBarTopProfile class="h-20 w-20 fill-gray-500 lg:mr-6 lg:group-hover:fill-black" />
    <span class="hidden lg:inline">{{ $t('header.top_profiles') }}</span>
  </CabHeaderNavWrap>
</template>
